module.exports = __webpack_public_path__ + "static/media/11_nugu_a.69e1f89e.ogg";